
import { defineComponent } from 'vue';
import ManagementContent from '../components/management/ManagementContent.vue';

export default defineComponent({
  name: 'ManagementView',
  components: {
    ManagementContent
  },
});
